import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { FirebaseService } from 'src/app/core/services/envios/firebase.service';
import { LocalstorageService } from 'src/app/core/services/localstorage.service';
import { hideIdInfo } from 'src/app/global/utils';
import { Order } from 'src/app/interfaces/orders.interface';
import { ProductsInfo } from 'src/app/interfaces/products.interface';
import { User } from 'src/app/interfaces/user.interface';

@Component({
  selector: 'app-order-price-info',
  templateUrl: './order-price-info.component.html',
  styleUrls: ['./order-price-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrderPriceInfoComponent implements OnInit, OnDestroy, OnChanges {

  @Input() productsInfo: ProductsInfo;
  @Input() order: Order;
  @Input() credits: number;
  @Input() isVariableWeight: boolean;

  @Output() onCreditsUsed = new EventEmitter<number>();

  public currentUser: User;
  public detailUrl: boolean;

  public freeDeliveryLimit = 0;

  public useCredits = true;
  public freeDelivery = false;

  // ✅ valores calculados (NO se calculan en el template)
  public deliveryCost = 0;
  public creditsUsed = 0;
  public total = 0;

  public piboxMessage: string | null = null;
  public showPiboxMessage = false;

  private subs = new Subscription();

  constructor(
    private router: Router,
    private localStorage: LocalstorageService,
    private firebaseService: FirebaseService
  ) { }

  ngOnInit(): void {
    this.currentUser = JSON.parse(this.localStorage.getItem('user'));
    this.detailUrl = this.router.url.includes('/order/order-detail');

    this.subs.add(
      this.firebaseService.getFreeDeliveryLimit().subscribe(limit => {
        this.freeDeliveryLimit = limit;
        // si el free delivery depende de esto, recalcula
        this.recalculateTotals();
      })
    );

    // primera vez
    this.recalculateTotals();
  }

  ngOnChanges(changes: SimpleChanges): void {
    // ✅ recalcula cuando cambien inputs
    if (changes.productsInfo || changes.credits || changes.isVariableWeight) {
      this.recalculateTotals();
    }
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  // ✅ método único para calcular, con side effects CONTROLADOS (NO se llama desde el template)
  private recalculateTotals(): void {
    const subtotal = this.productsInfo?.subtotal ?? 0;

    this.deliveryCost = this.productsInfo?.deliveryTax ?? 0;

    let total = subtotal + this.deliveryCost;

    // Créditos
    if (this.useCredits) {
      const usable = Math.min(this.credits ?? 0, total);
      this.creditsUsed = usable;
      total -= usable;
    } else {
      this.creditsUsed = 0;
    }

    if (this.productsInfo?.totalWithCredit) {
      total = this.productsInfo.totalWithCredit;
    }

    this.total = total;

    if (this.deliveryCost > 0) {
      this.showPiboxMessage = true;

      if (this.deliveryCost < 6000) {
        this.piboxMessage = 'Pibox reserva';
        console.log(this.piboxMessage);
      } else {
        this.piboxMessage = 'Pibox Demanda';
        console.log(this.piboxMessage);
      }
    } else {
      this.showPiboxMessage = false;
      this.piboxMessage = null;
    }
  }

  sendUseCredits(): void {
    this.recalculateTotals();
    this.onCreditsUsed.emit(this.creditsUsed);
  }

  checkIvaDelivery(): boolean {
    const finalSubtotal = this.productsInfo?.subtotal ?? 0;
    return finalSubtotal >= this.freeDeliveryLimit;
  }

  hideNit(id: number): string {
    return hideIdInfo(id);
  }
}
